import { jsx as c } from "react/jsx-runtime";
const o = (t) => /* @__PURE__ */ c(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    children: /* @__PURE__ */ c(
      "path",
      {
        fill: "#131317",
        d: "M17.427 22.5v-21h2.564v21zM8.364 19.45c-2.586 0-4.355-1.349-4.355-3.581 0-2.498 1.879-3.648 4.642-3.648 1.37 0 2.387.53 2.918.973v-1.57c0-1.06-.752-1.856-1.99-1.856-1.039 0-1.68.464-1.989 1.083H4.805c.663-2.233 2.453-3.426 4.929-3.426 2.873 0 4.84 1.746 4.84 4.42v7.34H11.68v-1.061c-.53.773-1.99 1.326-3.315 1.326m.773-1.99c1.326 0 2.432-.73 2.432-1.702 0-1.017-.995-1.613-2.343-1.613-1.415 0-2.3.574-2.3 1.635s.951 1.68 2.211 1.68"
      }
    )
  }
);
export {
  o as default
};
